var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure2F3204Cc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_azure"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9551 23.7324H13.0008C12.8525 23.7323 12.7076 23.7768 12.5849 23.8601C12.4623 23.9434 12.3676 24.0616 12.3132 24.1995C12.2588 24.3373 12.2472 24.4883 12.2799 24.6327C12.3126 24.7772 12.3882 24.9085 12.4966 25.0095L22.7485 34.5673C23.047 34.8454 23.44 34.9999 23.8482 34.9998H32.8822L28.9551 23.7324Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3326 3.00001C13.9932 2.99871 13.6623 3.10584 13.3882 3.30575C13.1141 3.50567 12.9112 3.78788 12.8091 4.11118L3.09395 32.8622C3.00721 33.1037 2.97998 33.3626 3.01457 33.6169C3.04916 33.8712 3.14455 34.1134 3.29268 34.323C3.44081 34.5327 3.63732 34.7036 3.86557 34.8214C4.09383 34.9392 4.34713 35.0003 4.60404 34.9996H12.6359C12.9351 34.9462 13.2147 34.8145 13.4462 34.6179C13.6777 34.4212 13.8528 34.1667 13.9536 33.8804L15.8911 28.1771L22.8113 34.6245C23.1013 34.8641 23.4652 34.9966 23.8415 34.9996H32.8418L28.8944 23.7321L17.3871 23.7347L24.43 3.00001H14.3326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.1837 4.08835C27.0765 3.77112 26.8724 3.49547 26.6001 3.30022C26.3278 3.10497 26.0011 2.99997 25.6659 3H14.4531C15.1404 3 15.7511 3.43791 15.9709 4.08835L25.7018 32.888C25.7831 33.1288 25.8059 33.3854 25.7683 33.6366C25.7306 33.8879 25.6336 34.1266 25.4853 34.333C25.337 34.5394 25.1416 34.7075 24.9153 34.8235C24.689 34.9395 24.4383 35 24.184 35H35.3973C35.6516 34.9999 35.9022 34.9394 36.1285 34.8234C36.3547 34.7073 36.55 34.5392 36.6983 34.3328C36.8466 34.1264 36.9436 33.8878 36.9812 33.6365C37.0188 33.3853 36.996 33.1287 36.9146 32.888L27.1835 4.08835H27.1837Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure2F3204Cc);
export default __webpack_public_path__ + "static/media/azure-2f3204cc.05c91db0f3e1f1dba001665260bf36d0.svg";
export { ForwardRef as ReactComponent };